/**
 * Канал поддержки, который работает независимо от AI-контура.
 *
 * Нужен именно как константа: при отказе бэкенда поддержки пользователю нельзя
 * показывать выдуманного оператора или локально сочинённый ответ (запрет заглушек
 * в боевом пути), но нельзя и оставлять его без выхода — в сообщении об отказе
 * даётся этот адрес. Совпадает с адресом на странице контактов и в ToS.
 */
export const SUPPORT_EMAIL = "support@eventmaster.events";
